// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.watermarkcontainer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 11;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 25px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.128);
  pointer-events: none;
  letter-spacing: 0;
  text-align: center;
}
.watermark_user_name {
  width: 70%;
  max-width: 550px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/WaterMark/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".watermarkcontainer {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  z-index: 11;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  font-size: 25px;\r\n  font-weight: 600;\r\n  color: rgba(0, 0, 0, 0.128);\r\n  pointer-events: none;\r\n  letter-spacing: 0;\r\n  text-align: center;\r\n}\r\n.watermark_user_name {\r\n  width: 70%;\r\n  max-width: 550px;\r\n  margin: 0 auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
